<!-- =========================================================================================
  File Name: Invoice.vue
  Description: Invoice Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div v-if="dadosProposta.dadosCliente" class="wrapperPage pt-8">
    <div
      class="sm:pl-0 container flex flex-col items-center sm:flex-row sm:justify-between"
    ></div>
    <div class="container">
      <div class="logo w-full p-1 flex justify-center sm:justify-start">
        <img class="" :src="dadosProposta.dadosAssociacao.logo" width="200" />
      </div>
      <div class="dadosBP w-full p-1 text-sm">
        <h3 class="flex justify-center">{{ $t('CONTRATO') }}</h3>
      </div>
      <vx-card class="mt-5">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">{{ $t('DADOS') }} {{ $t('PESSOAIS') }}</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Nome') }}</b>:
              {{
                dadosProposta.dadosCliente.associado
                  ? dadosProposta.dadosCliente.associado
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>{{ $t('CPF') }} / {{ $t('CNPJ') }}</b>:
              {{
                dadosProposta.dadosCliente.cpf
                  ? dadosProposta.dadosCliente.cpf
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('E-mail') }}</b>:
              {{
                dadosProposta.dadosCliente.email
                  ? dadosProposta.dadosCliente.email
                  : ''
              }}
            </td>
            <td class="pl-3">
            <b>{{ $t('RG') }}</b>:
              {{
                dadosProposta.dadosCliente.rg_ie
                  ? dadosProposta.dadosCliente.rg_ie
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Telefone') }}</b>:
              {{
                dadosProposta.dadosCliente.telefone
                  ? dadosProposta.dadosCliente.telefone
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Celular') }}</b>:
              {{
                dadosProposta.dadosCliente.celular
                  ? dadosProposta.dadosCliente.celular
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('CNH') }}</b>:
              {{
                dadosProposta.dadosCliente.cnh
                  ? dadosProposta.dadosCliente.cnh
                  : ''
              }}
            </td>
            <td class="pl-3">
             <b>N° {{ $t('Proposta') }}</b>:
              {{ dadosProposta.idProposta ? dadosProposta.idProposta : '' }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Data de Nascimento') }}</b>:
              {{
                dadosProposta.dadosCliente.dataNascimento != 'Invalid date'
                  ? dadosProposta.dadosCliente.dataNascimento
                  : ''
              }}
            </td>
            <td class="pl-3"></td>
          </tr>
        </table>
      </vx-card>
      <vx-card class="mt-3">
        <table class="table">
          <tr class="title p-1 w-full">
           <th colspan="4">{{ $t('ENDEREÇO') }} {{ $t('DE') }} {{ $t('CORRESPONDÊNCIA') }}</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Endereço') }}</b>:
              {{
                dadosProposta.dadosCliente.endereco
                  ? dadosProposta.dadosCliente.endereco
                  : ''
              }}
            </td>
            <td class="pl-3">
             <b>{{ $t('Número') }}</b>:
              {{
                dadosProposta.dadosCliente.numero
                  ? dadosProposta.dadosCliente.numero
                  : ''
              }}
            </td>
            <td class="pl-3" colspan="2">
              <b>{{ $t('Complemento') }}</b>:
              {{
                dadosProposta.dadosCliente.complemento
                  ? dadosProposta.dadosCliente.complemento
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Bairro') }}</b>:
              {{
                dadosProposta.dadosCliente.bairro
                  ? dadosProposta.dadosCliente.bairro
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Cidade') }}</b>:
              {{
                dadosProposta.dadosCliente.cidade
                  ? dadosProposta.dadosCliente.cidade
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Estado') }}</b>:
              {{
                dadosProposta.dadosCliente.estado
                  ? dadosProposta.dadosCliente.estado
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>{{ $t('CEP') }}</b>:
              {{
                dadosProposta.dadosCliente.cep
                  ? dadosProposta.dadosCliente.cep
                  : ''
              }}
            </td>
          </tr>
        </table>
      </vx-card>
      <vx-card class="mt-3">
        <table class="table">
          <tr class="title p-1 w-full">
            <th colspan="4">{{ $t('DADOS') }} {{ $t('DO') }} {{ $t('VEÍCULO') }}</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Tipo') }}</b>:
              {{ $t(dadosProposta.nomeTipo, { msg: dadosProposta.nomeTipo }) }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Marca') }}</b>: {{ dadosProposta.dadosVeiculo.veiculoMarca }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Modelo') }}</b>: {{ dadosProposta.dadosVeiculo.veiculoModelo }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Ano') }} {{ $t('Fabricação') }}</b>:
              {{
                dadosProposta.dadosVeiculo.anoFabricacao === anoFabricacao0km
                  ? '0Km'
                  : dadosProposta.dadosVeiculo.anoFabricacao
              }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Ano') }} {{ $t('Modelo') }}</b>:
              {{
                dadosProposta.dadosVeiculo.anoModelo === anoFabricacao0km
                  ? '0Km'
                  : dadosProposta.dadosVeiculo.anoModelo
              }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Cor') }}</b>: {{ dadosProposta.dadosVeiculo.cor }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Chassi') }}</b>: {{ dadosProposta.dadosVeiculo.chassi }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Placa') }}</b>: {{ removeHifen(dadosProposta.dadosVeiculo.placa) }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Renavam') }}</b>: {{ dadosProposta.dadosVeiculo.renavam }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
             <b>{{ $t('Valor') }} {{ $t('FIPE') }}</b>:
              {{ dadosProposta.dadosVeiculo.valorFipe | currency }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Código') }} {{ $t('FIPE') }}</b>: {{ dadosProposta.dadosVeiculo.codigoFipe }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Capital') }} {{ $t('segurado') }}</b>:
              {{
                dadosProposta.implemento
                  ? dadosProposta.dadosVeiculo.valorFipe
                  : dadosProposta.dadosVeiculo.valorCobertura | currency
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Dia') }} {{ $t('Vencimento') }}</b>:
              {{ dadosProposta.diaVencimentoMensalidade }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Entrada') }}</b>:
              {{
                somaValorTotalValoresAvista(dadosProposta.produtos) | currency
              }}
            </td>
            <td class="pl-3">
            <b>{{ $t('Grupo') }} {{ $t('Veículo') }}</b>: {{ dadosProposta.nomeGrupo }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Franquia') }}</b>:
              {{
                dadosProposta.valorCotaParticipacao
                  ? `${dadosProposta.valorCotaParticipacao}% `
                  : ' '
              }}
              {{
                dadosProposta.valorParticipacaoMinimo
                  ? ` mínimo de R$ ${dadosProposta.valorParticipacaoMinimo}`
                  : ''
              }}
            </td>
            <td class="pl-3" colspan="2">
              <b>{{ $t('Você') }} {{ $t('possui') }} {{ $t('garagem') }} {{ $t('para') }} {{ $t('guarda') }} {{ $t('do') }} {{ $t('veículo') }}?</b>:
              {{ dadosProposta.nomeTipoEstacionamento }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="4">
              <b>{{ $t('Observações') }}</b>: {{ dadosProposta.observacao }}
            </td>
          </tr>
        </table>

        <div v-if="dadosProposta.implemento">
          <table
            v-for="(implemento, index) in dadosProposta.implementos"
            :key="`id-${index}`"
            class="table mt-6"
          >
            <tr v-if="index == 0" class="title p-1 w-full">
              <th colspan="4">
                {{ formatTitle('implemento') }}
              </th>
            </tr>
            <tr>
              <td class="pl-3">
                <b>{{ $t('Tipo') }}</b>: {{ $t(implemento.tipo, { msg: implemento.tipo }) }}
              </td>
             <td class="pl-3"><b>{{ $t('Marca') }}</b>: {{ implemento.marca }}</td>
             <td class="pl-3"><b>{{ $t('Modelo') }}</b>: {{ implemento.modelo }}</td>
            </tr>
            <tr v-if="implemento.anoFabricacao || implemento.anoModelo">
              <td v-if="implemento.anoFabricacao" class="pl-3">
               <b>{{ $t('Ano') }} {{ $t('Fabricação') }}</b>:
                {{ implemento.anoFabricacao }}
              </td>
              <td v-if="implemento.anoModelo" class="pl-3">
               <b>{{ $t('Ano') }} {{ $t('Modelo') }}</b>:
                {{
                  implemento.anoModelo === anoFabricacao0km
                    ? '0Km'
                    : implemento.anoModelo
                }}
              </td>
            </tr>
            <tr v-if="implemento.chassi">
              <td class="pl-3"><b>{{ $t('Chassi') }}</b>: {{ implemento.chassi }}</td>
              <td class="pl-3">&nbsp;</td>
            </tr>
            <tr v-if="implemento.placa">
              <td class="pl-3"><b>{{ $t('Placa') }}</b>: {{ implemento.placa }}</td>
              <td class="pl-3">&nbsp;</td>
            </tr>
            <tr>
              <td class="pl-3" colspan="3">
                <b>{{ $t('Capital') }} {{ $t('segurado') }}</b>:
                {{ implemento.valorCobertura | currency }}
              </td>
            </tr>
          </table>
        </div>

        <!-- valor total de cobertura -->
        <div v-if="dadosProposta.implemento">
          <table class="table mt-6">
            <tr class="title p-1 w-full">
            <th colspan="4">{{ $t('VALOR') }} {{ $t('COBERTURA') }} {{ $t('DO') }} {{ $t('CONJUNTO') }}</th>
            </tr>
            <tr>
              <td class="pl-3" colspan="4">
              <b>{{ $t('Capital') }} {{ $t('segurado') }} {{ $t('do') }} {{ $t('conjunto') }} ({{ $t('Caminhão') }} + {{ $t('implemento') }})</b>:
                {{ dadosProposta.valorTotalConjunto | currency }}
              </td>
            </tr>
          </table>
        </div>

        <!-- agregados -->
        <div v-if="dadosProposta.agregado">
          <!-- agregados unificados -->
          <table
            v-for="(agregado, index) in dadosProposta.agregados"
            :key="`id-${index}`"
            class="table mt-6"
          >
            <tr v-if="index === 0" class="title p-1 w-full">
              <th colspan="4">
                {{ formatTitle('agregado') }}
              </th>
            </tr>
            <tr>
              <td class="pl-3">
             <b>{{ $t('Tipo') }}</b>: {{ $t(agregado.tipo, { msg: agregado.tipo }) }}
              </td>
              <td class="pl-3">
             <b>{{ $t('Marcas') }}</b>: {{ agregado.marca }}
              </td>
              <td class="pl-3">
             <b>{{ $t('Modelo') }}</b>: {{ agregado.modelo }}
              </td>
            </tr>
            <tr v-if="agregado.anoFabricacao || agregado.anoModelo">
              <td v-if="agregado.anoFabricacao" class="pl-3">
                <b>{{ $t('Ano') }} {{ $t('Fabricação') }}</b>: {{ agregado.anoFabricacao }}
              </td>
              <td v-if="agregado.anoModelo" class="pl-3">
                <b>{{ $t('Ano') }} {{ $t('Modelo') }}</b>: {{ agregado.anoModelo }}
              </td>
            </tr>
            <tr v-if="agregado.chassi || agregado.placa">
              <td class="pl-3">
                <strong>{{ $t('Chassi') }}</strong>: {{ agregado.chassi }}
              </td>
              <td class="pl-3">
                <strong>{{ $t('Placa') }}</strong>: {{ agregado.placa }}
              </td>
              <td class="pl-3">&nbsp;</td>
            </tr>
          </table>
          <table class="table mt-6">
            <tr class="title p-1 w-full">
              <th colspan="4">
                {{ $t('RESUMO') }} {{ $t('DOS') }} {{ $t('AGREGADO') }}
              </th>
            </tr>
            <tr>
              <td class="pl-2">
                <strong>{{ $t('Capital') }} {{ $t('Segurado') }}</strong>:
                {{ somarCapitalSegurado(dadosProposta.agregados) | currency }}
              </td>
              <td class="pl-3">
                <strong>{{ $t('Mensalidade') }}</strong>:
                {{
                  somaValorTotalValoresAvista(
                    dadosProposta.agregados[0].produtosAgregado,
                  ) | currency
                }}
              </td>
              <td class="pl-3">
                <strong>{{ $t('Franquia') }}</strong>:
                {{ propostaParticipacaoAgregado() }}
                {{ `, mínimo de R$ ${propostaParticipacaoAgregado()}` }}
              </td>
            </tr>
          </table>
        </div>
      </vx-card>
      <vx-card class="mt-3">
        <table class="table">
          <tr class="title p-1 w-full">
            <b>{{ $t('COBERTURAS') }} {{ $t('E') }} {{ $t('BENEFÍCIOS') }}</b>:
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ $t('Plano') }}</b>:
              {{
                dadosProposta.idEmpresa == 120
                  ? 'BEM PROTEGE'
                  : dadosProposta.dadosAssociacao.nome
              }}
            </td>
            <td class="pl-3">
              <b>{{ $t('Valor') }} {{ $t('do') }} {{ $t('Plano') }}</b>:
              {{ somaValorTotalMensal(dadosProposta.produtos) | currency }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="4">
             <b>{{ $t('Benefícios') }} {{ $t('do') }} {{ $t('Plano') }}</b>:
              <span
                v-for="beneficio in dadosProposta.beneficios"
                :key="beneficio.i"
              >
                {{ beneficio.nome }},
                <span v-if="beneficio.descricao"
                  >{{ beneficio.descricao }},
                </span>
              </span>
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="4">
              <b>{{ $t('Coberturas') }}</b>:
              <span
                v-for="produto in filtraProdutosPlano(dadosProposta.produtos)"
                :key="produto.i"
              >
                {{ produto.nomeProduto }},
              </span>
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="4">
              <b>{{ $t('Pagamento') }} {{ $t('mensal') }}</b>:
              {{ somaValorTotalMensal(dadosProposta.produtos) | currency }}
            </td>
          </tr>
        </table>
      </vx-card>

      <vx-card class="mt-3">
        <div
          style="text-align: justify"
          class="textoContrato"
          v-html="textoContrato"
        ></div>
        <div class="mt-8">
          {{
            dadosProposta.dadosCliente.cidade
              ? dadosProposta.dadosCliente.cidade
              : ''
          }},
          {{
            formataData(
              dadosProposta.dataFinalizacao ||
                dadosProposta.dataSincronizacaoSga ||
                dadosProposta.createdAt,
            )
          }}
        </div>
        <vs-list class="mt-12 mb-12">
          <vs-list-item
            class="text-base p-3"
            v-for="termo in termosContrato"
            :key="termo.idModelo"
            :title="termo.tipoContrato"
            :subtitle="formatarData(termo.updatedAt)"
            icon-pack="feather"
            icon="icon-file-text"
          >
            <a
              class="p-3"
              :href="`/termoContrato/${termo.idModelo}/${chave || ''}`"
              target="_blank"
            >
              <vs-icon
                icon-pack="feather"
                icon="icon-external-link"
                size="small"
                color="gray"
              >
              </vs-icon>
            </a>
          </vs-list-item>
        </vs-list>
        <div class="flex flex-col sm:flex-row sm:justify-around mt-12">
          <div class="items-left">
            <img
              v-if="
                this.dadosProposta.idEmpresa === EMPRESAS_BP.ERP_GERAL ||
                this.dadosProposta.idEmpresa === EMPRESAS_BP.BP_STIP ||
                this.dadosProposta.idEmpresa === EMPRESAS_BP.BR ||
                this.dadosProposta.idEmpresa === EMPRESAS_BP.BPVCMENSAL
              "
              class="imagem"
              src="https://bboneapp.s3.amazonaws.com/assinatura-contrato-bp1.png"
              width="200"
            />
            <img
              v-if="this.dadosProposta.idEmpresa == EMPRESAS_BP.ERP_VIAVANTE"
              class="imagem"
              src="https://bboneapp.s3.amazonaws.com/assinatura-viavante.png"
              height="100"
            />
            <img
              v-if="this.dadosProposta.idEmpresa === EMPRESAS_BP.BP_TRUCK"
              class="imagem"
              src="https://bboneapp.s3.amazonaws.com/assinatura-bp-truck.png"
              height="100"
            />
            <p><b>____________________________________</b></p>
            <p>
              <b> {{ getNomeEmpresa() }}</b>
            </p>
            <P
              ><b>{{ dadosProposta.dadosAssociacao.cnpj }}</b></P
            >
          </div>
          <div>
            <img
              v-if="dadosProposta.assinatura"
              class="imagem"
              :src="dadosProposta.assinatura"
              height="100"
              style="margin-left: 15px"
            />
            <div v-else style="height: 100px; margin-left: 15px"></div>
            <p><b>____________________________________</b></p>
            <p>
              <b>{{ dadosProposta.dadosCliente.associado }}</b>
            </p>
            <p>
              <b>{{ dadosProposta.dadosCliente.cpf }}</b>
            </p>
          </div>
        </div>
        <div class="mt-5 flex justify-end">
          <vs-button
            color="success"
            type="gradient"
            class="w-2/6 btn-print"
            @click="imprimePDF()"
          >
            {{ $t('Exportar') }} {{ $t('PDF') }}
          </vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import service from '../../services';
import locale from './../../locale';
import VxCard from '../../components/vx-card/VxCard.vue';
import jwt from 'jsonwebtoken';
import { BP } from '../../commons/constant/empresasBp';
import { getTranslate } from '@/services/translate/translate';
import { decryptData } from '@/services/decryptData';

export default {
  data() {
    return {
      dadosProposta: {},
      textoContrato: '',
      mascaraCarro: null,
      mascaraMoto: null,
      mascaraCaminhao: null,
      mascaraAgregado: null,
      mascaraImplemento: null,
      ativaMascarasVeiculos: null,
      termosContrato: [],
      idProposta: this.$route.params.idProposta || null,
      chave: this.$route.params.chave || null,
      anoFabricacao0km: 32000,
      EMPRESAS_BP: {},
    };
  },
  computed: {},
  methods: {
    async translate(companyId) {
      const translate = await getTranslate(companyId);
      if (translate) {
        const nameDefaultLocale = `defaultLabels`;
        this.$i18n.mergeLocaleMessage(nameDefaultLocale, translate);
        this.$i18n.locale = nameDefaultLocale;
      }
    },
    getNomeEmpresa() {
      return this.dadosProposta.idEmpresa === BP.ERP_GERAL
        ? 'Bem Protege'
        : this.dadosProposta.dadosAssociacao.nome;
    },
    formatTitle(type) {
      const isImplemento = type === 'implemento';
      const count = isImplemento
        ? this.dadosProposta.implementos.length
        : this.dadosProposta.agregados.length;
      const typeLabel = this.$t(isImplemento ? 'IMPLEMENTO' : 'AGREGADO');

      const pluralSuffix = count > 1 ? 'S' : '';
      const titlePrefix = count > 1 ? 'DOS' : 'DO';
      const pluralMaskSuffix =
        count && !this.ativaMascarasVeiculos > 1 ? 'S' : '';

      const title = `DADO${pluralSuffix} ${titlePrefix} ${typeLabel}${pluralMaskSuffix}`;
      return title;
    },
    filtraProdutosPlano(produtos) {
      return produtos.filter(
        (x) =>
          x.nomeProduto != 'Taxa Administrativa' &&
          x.nomeProduto != 'Mensalidade',
      );
    },
    propostaParticipacaoAgregado() {
      return this.dadosProposta.agregados[0].porcentagemParticipacao || 0;
    },
    imprimePDF() {
      window.print();
    },
    somarCapitalSegurado(itens) {
      const valorTotalCapitalSeguradoIgnorado = 0.2;
      return itens.reduce((acc, prod) => {
        if (Number(prod.valorCobertura) > valorTotalCapitalSeguradoIgnorado) {
          acc += Number(prod.valorCobertura);
        }
        return acc;
      }, 0);
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    somaValorTotalValoresAvista(arr1) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal != true) total = total + element.valorFinal;
        });
      return total;
    },
    somaValorTotalMensal(produtos) {
      const { comissaoAplicada } = this.dadosProposta;

      let totalMensal = produtos.reduce(
        (acumulador, { isMensal, valorFinal }) => {
          return isMensal ? acumulador + valorFinal : acumulador;
        },
        0,
      );

      if (this.dadosProposta.agregado) {
        const agregadosUnificados = this.dadosProposta.agregados.find(
          (agregado) => agregado.unificarAgregados,
        );

        if (agregadosUnificados) {
          const agregado = this.dadosProposta.agregados[0];

          const { produtosAgregado } = agregado;

          const totalProdutosAgregado = produtosAgregado.reduce(
            (totalSomaProdAgregados, produto) => {
              if (produto.isMensal) {
                totalSomaProdAgregados += produto.valorFinal;
              }

              return totalSomaProdAgregados;
            },
            0,
          );
          totalMensal += totalProdutosAgregado;
        } else {
          this.dadosProposta.agregados.forEach((agregado) => {
            const { produtosAgregado } = agregado;

            const totalProdutosAgregado = produtosAgregado.reduce(
              (totalSomaProdAgregados, produto) => {
                if (produto.isMensal) {
                  totalSomaProdAgregados += produto.valorFinal;
                }

                return totalSomaProdAgregados;
              },
              0,
            );

            totalMensal += totalProdutosAgregado;
          });
        }
      }
      const totalComComissao = comissaoAplicada
        ? totalMensal + (totalMensal * comissaoAplicada) / 100
        : totalMensal;
      return totalComComissao;
    },
    buscaDados() {
      if (this.$route.query.interno) {
        this.isInterno = true;
      } else {
        this.isInterno = false;
      }
      this.chave = this.$route.params.chave;
      this.idProposta = this.$route.params.idProposta;
      this.$vs.loading();
      var objSend = {};
      objSend.chave = this.$route.params.chave;
      objSend.idProposta = this.$route.params.idProposta;

      service
        .post('CotacaoAberta', 'buscaDados', objSend)
        .then((res) => {
          this.dadosProposta = res.data[0];

          let textoContrato = res.data[0].termos.find(
            (x) => x.tipoContrato == 'Termo de Ativação',
          );
          if (this.dadosProposta.tipoProposta == 'Reativação') {
            textoContrato = res.data[0].termos.find(
              (x) => x.tipoContrato == 'Termo de Reativação',
            );
          }
          this.textoContrato = textoContrato && textoContrato.modeloContrato;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    async buscaDadosEmpresa() {
      if (localStorage.getItem('user-token')) {
        try {
          this.$vs.loading();
          const decoded = jwt.decode(localStorage.getItem('user-token'));
          this.idEmpresa = decoded.id_empresa;

          const res = await service.getAll(
            'g',
            {},
            'empresas/list/idEmpresa/' + this.idEmpresa,
          );

          const [Empresa] = decryptData(res.data);

          if (Empresa.ativaMascarasVeiculos) {
            this.ativaMascarasVeiculos = Empresa.ativaMascarasVeiculos;
          }
          await this.translate(Empresa.idEmpresa);

          this.$vs.loading.close();
        } catch (error) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
          this.$vs.loading.close();
        }
      }
    },
    async buscaTermos() {
      try {
        this.$vs.loading();
        const { data } = await service.post(
          'ModelosContratos',
          'BuscaContrato',
          { idEmpresa: this.idEmpresa },
        );
        this.termosContrato = data.filter(
          (item) => item.termoContratoAdesao === true,
        );
      } catch (error) {
        this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: error,
        color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    formatarData(dataString) {
      const data = new Date(dataString);
      return data.toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    removeHifen(placa) {
      if (!placa) {
        return;
      }
      const placaSemHifen = placa.replace('-', '');
      return placaSemHifen;
    },
  },
  mounted() {
    this.buscaDadosEmpresa();
    this.EMPRESAS_BP = BP;
    if (!this.idEmpresa) {
      return;
    }
    this.buscaTermos();
  
  },
  created() {
    this.buscaDados();
    this.$validator.localize('ptBr', locale);
  },
  components: { VxCard },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.wrapperPage {
  font-family: 'regular', 'Gotham', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}

table {
  width: 100%;
  gap: 20px;
}

tr:nth-child(odd) {
  background-color: #edf4fb;
}

.title {
  background-color: #043562 !important;
  color: white;
}

.listItemsProtecoes {
  color: rgb(59, 59, 59);
  font-size: 0.9rem;
  font-weight: 600;
}

.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 296mm;
}
.A4 .sheet {
  width: 210mm;
  height: 296mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 209mm;
}
.A5 .sheet {
  width: 148mm;
  height: 209mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}
/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
    display: flex;
    justify-content: center;
  }
  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin-top: 1em;
    margin-bottom: 1em;
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
@media screen {
  .printer {
    display: none;
  }
}
@media print {
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .pdf {
    width: auto;
    height: 200mm;
  }
  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}
</style>
